import { app } from '../../../../bootstrap/core';
import { ticketStatusComponent } from './ticketStatus.component';

app.component('ticketStatus', ticketStatusComponent);
